<template>

  <v-container fluid fill-height ma-0 pa-0>

    <v-layout fill-height pa-0>

      <v-flex xs12 px-0>

        <v-layout column fill-height justify-start ma-0 pl-0>

          <v-toolbar dense flat color="white" height="42">
            <v-toolbar-title class="subtitle-2 back--text text-uppercase">
              <v-layout fill-height align-center ma-0 pb-2 pl-2 style="position: relative">

                <v-menu
                  v-model="bar.filter.open"
                  :close-on-content-click="false"
                  :close-on-click="true"
                  :nudge-width="100"
                  offset-y   
                  bottom
                >

                  <template v-slot:activator="{ on }">
                    <v-flex shrink v-for="(page, index) in getTabs" :key="index">
                      <v-layout :class="getTabs[activeTab] == page && (page == 'realtime' || page == 'archive') ? 'journal-tab-button active' : 'journal-tab-button'" 
                      :data-testid="$options.name + '__tab__' + page"
                      @click.stop="() => onJournalBattonClick(page, index)" align-center>
                        <svg-icon
                          :color="'blacktext'"
                          :name="page"
                          width="20"
                        />
                          <v-flex shrink px-2>
                          <span class="blacktext--text">{{ $t(page) }}</span> 
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </template>

                  <filter-bar
                    v-show="bar.filter.open"
                    :size="500"
                    :data="getTasks"
                    :columns="getDescriptor.columns"
                    :columnsFilter="getFilterColumns"
                    :mode="bar.filter.mode"
                    @filter="(payload) => applyFilter(payload)"
                    @close="()=>{bar.filter.open = false}"
                  />

                </v-menu>
             
              </v-layout>
            </v-toolbar-title>

            <v-layout fill-height align-baseline ma-0 pa-0>

            </v-layout>

            <v-spacer></v-spacer>

          </v-toolbar>

          <v-flex style="position: relative">
            <v-layout class="white" column fill-height px-4>
              <v-layout fill-height>

                <wrapper 
                  ref="descriptor_wrapper"
                  :data="getTasks"
                  :descriptor="getDescriptor"
                  :filter="getFilter"
                  :pdfDialogShow="getPdfDialogShow"
                  @sort="(item) => sortTable(item)"
                  @select="(payload) => selectRecord(payload)"
                  @value="(row, item) => clickValue(row, item)"
                  @pdfReportsClose="(e) => onPdfReportsClose(e)"
                />
              </v-layout>

              <v-layout class="text-xs-center pt-2" justify-center>

                <v-btn :disabled="getPage == 0" flat small icon :data-testid="$options.name + '__btn__' + 'first'" @click="() => moveToPage('first')" class="transparent">
                  <v-icon>first_page</v-icon>
                </v-btn>
                <v-btn :disabled="getPage == 0" flat small icon :data-testid="$options.name + '__btn__' + 'prevPage'" @click="() => prevPage()" class="transparent">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'getPage1'" v-if="!this.curRealArch" small icon flat class="transparent">{{getPage + 1}}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'getPage1'" v-if="!!this.curRealArch" small icon flat class="transparent">{{getPage + 1}}</v-btn>

                <v-btn :disabled="getTasks.length < pageLimit || getPage == getTotalPages" small icon flat :data-testid="$options.name + '__btn__' + 'nextPage'" @click="() => nextPage()" class="transparent">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn :disabled="getPage == getTotalPages || getTotalPages == 1" small icon flat :data-testid="$options.name + '__btn__' + 'last'" @click="() => moveToPage('last')" class="transparent">
                  <v-icon>last_page</v-icon>
                </v-btn>

              </v-layout>

            </v-layout>

          </v-flex>

          <v-navigation-drawer
            v-model="bar.equipment.open"
            :class="bar.equipment.open ? 'transparent elevation-10' : 'transparent'"
            hide-overlay
            right
            absolute
            width="1200"
            class="py-1"
            disable-resize-watcher
          >
            <equipment-panel
              :bar="true"
              @close="()=>{bar.equipment.open = false}"
            />

          </v-navigation-drawer>

        </v-layout>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import trtd from '@/nms/components/partials/tasksRealtimeTableDescriptor.js'
import tatd from '@/nms/components/partials/tasksArchiveTableDescriptor.js'
import wrapper from '@/nms/components/partials/descriptor-wrapper.vue'
import filterBar from '@/nms/components/partials/filter-bar.vue'
import equipmentPanel from '@/nms/pages/equipment/equipment.vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import myFont from '@/nms/assets/RobotoCondensed-Regular-normal.js'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface TableColumn {
  title: string
  value: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: Record<string, any>[]
}

interface FilterData {
  date?: {
    startRT?: string
    endRT?: string
  }
  maps?: any[]
  [key: string]: any
}

interface BarState {
  filter: { open: boolean; mode: string }
  equipment: { open: boolean }
}

interface DialogState {
  confirm: {
    open: boolean
    comment: string
    noComment: boolean
    mode: string
  }
  pdf: { show: boolean }
}

interface TaskRecord {
  id?: string
  [key: string]: any
}

interface CustomQueryResponse {
  data?: {
    data?: TaskRecord[]
    pages?: number
    total?: number
  }
  [key: string]: any
}

export default Vue.extend({
  name: 'TASKS_JOURNAL',

  components: {
    wrapper,
    filterBar,
    equipmentPanel,
    svgIcon,
  },

  props: {
    title: {
      type: String,
      default: () => ''
    },
    show: {
      type: Boolean,
      default: () => false
    },
  },

  watch: {
    show: {
      handler(newVal): void {
        if(!newVal) return
        this.applyFilter()
      },
      deep: true
    },
  },

  data(): {
    realArch: boolean
    curRealArch: number
    activeTab: number
    bar: BarState
    dialog: DialogState
    tasks: TaskRecord[]
    archiveTasks: TaskRecord[]
    filter: FilterData
    search: string
    sort: string
    filterColumns: Record<string, any>
    filterPath: string
    table: TableData
    pageLimit: number
    page: number
    totalPages: number
    totalRecords: number
    archivePage: number
    totalArchivePages: number
    totalArchiveRecords: number
    nextPageButton: boolean
  } {
    return {
      realArch: false,
      curRealArch: 0,
      activeTab: 1,
      bar: {
        filter: { open: false, mode: 'operation' },
        equipment: { open: false },
      },
      dialog: {
        confirm: {
          open: false,
          comment: '',
          noComment: false,
          mode: 'confirm',
        },
        pdf: { show: false },
      },
      tasks: [],
      archiveTasks: [],
      filter: {},
      search: '',
      sort: '',
      filterColumns: {},
      filterPath: 'showFullPath',
      table: {
        columns: [],
        rows: [],
      },
      pageLimit: 40,
      page: 0,
      totalPages: 1,
      totalRecords: 1,
      archivePage: 0,
      totalArchivePages: 1,
      totalArchiveRecords: 1,
      nextPageButton: true,
    }
  },

  computed: {
    getTasks(): TaskRecord[] {
      if (!!this.curRealArch) {
        return this.$store.getters.getTopicRecords('e-nms/archiveTasks') || []
      } else {
        return this.$store.getters.getTopicRecords('e-nms/tasks') || []
      }
    },

    getDescriptor(): Record<string, any> {
      if (!!this.curRealArch) {
        return tatd || {}
      } else {
        return trtd || {}
      }
    },

    getFilter(): FilterData {
      return this.filter
    },

    getTabs(): string[] {
      return ['filter', 'realtime', 'archive', 'pdf', 'csv']
    },

    getPage(): number {
      if (!!this.curRealArch) {
        return this.archivePage
      } else {
        return this.page
      }
    },

    getTotalPages(): number {
      if (!!this.curRealArch) {
        return this.totalArchivePages
      } else {
        return this.totalPages
      }
    },

    getFilterColumns(): Record<string, any> {
      return this.filterColumns
    },

    getPdfDialogShow(): boolean {
      return this.dialog.pdf.show
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
      this.applyFilter()
  },

  methods: {
    async setup(): Promise<void> {
      // Метод предназначен для переопределения при необходимости
    },

    async subscribeRecords(caller?: string): Promise<void> {
      try {
        const client = this.$store.getters.getMqttClient
        console.log('TASKS_JOURNAL', 'subscribeRecords', 'client', client)
        this.$store.dispatch('mqttSubscribeTopic', 'e-nms/tasks/#')

        if (client) {
          const topic = 'e-nms/tasks/#'
          await client.unsubscribe(topic)
          this.$store.commit('SET_TOPIC', 'e-nms/tasks')
          client.subscribe(topic, { retain: true }, (err?: Error) => {
            console.log('TASKS_JOURNAL subscribeRecords', 'subscribe topic', topic, err)
          })
        }
      } catch (err) {
        console.error('CATCH', 'TASKS_JOURNAL', 'subscribeRecords', err)
      }
    },

    async loadTasks(caller?: string): Promise<void> {
      this.table = { columns: [], rows: [] }

      let filter: FilterData = {}
      if (Object.keys(this.filter).length) {
        filter = await this.prepareFilter()
      }
      filter.page = this.page

      const tasks = await this.$bridge.customQuery('alarm', 'task_manager/showTaskWithFilter', { filter, count: this.pageLimit, page: this.page, }, 'post') as CustomQueryResponse

      if (tasks) {
        this.totalPages = tasks?.data?.pages || 1
        this.totalRecords = tasks?.data?.total || 1
        this.tasks = tasks?.data?.data || tasks?.data || []
        this.$store.commit('SET_TOPIC_RECORD', { topic: 'e-nms/tasks', task: tasks?.data?.data || tasks?.data })
      }

      await this.subscribeRecords('loadTasks')

      const tempFilter = { ...filter }
      if (!tempFilter.maps) {
        tempFilter.maps = []
      }
      tempFilter.page = this.archivePage

      const archiveTasks = await this.$bridge.customQuery('alarm', 'logs_enode/', {
        table: 'tasks',
        filter: tempFilter,
        count: this.pageLimit,
      }, 'post') as CustomQueryResponse

      if (archiveTasks) {
        this.totalArchivePages = archiveTasks?.data?.pages || 1
        this.totalArchiveRecords = archiveTasks?.data?.total || 1
        this.archiveTasks = archiveTasks?.data?.data || archiveTasks?.data || archiveTasks || []
        this.$set(this.table, 'rows', this.archiveTasks)
        this.$store.commit('SET_TOPIC_RECORD', { topic: 'e-nms/archiveTasks', task: this.archiveTasks })
      }
    },

    async prepareFilter(): Promise<FilterData> {
      const $filter: FilterData = {}

      if (!Object.keys(this.filter).length) {
        return $filter
      }

      Object.keys(this.filter).forEach(key => {
        const val = key.split('.')

        if (val?.length > 1) {
          if (!$filter[val[0]]) {
            $filter[val[0]] = []
          }
          $filter[val[0]].push({ [val[1]]: this.filter[key] })
        } else {
          if (key === 'date') {
            if (this.filter.date?.startRT) {
              $filter.fromRt = this.filter.date.startRT
            }
            if (this.filter.date?.endRT) {
              $filter.toRt = this.filter.date.endRT
            }
          } else {
            $filter[key] = this.filter[key]
          }
        }
      })

      return $filter
    },

    sortTable(item: TableColumn): void {
      if (this.sort === item.value) {
        this.sort = '-' + item.value
      } else {
        this.sort = item.value
      }
    },

    applyFilter(barFilter?: FilterData): void {
      if (barFilter) {
        this.filter = barFilter
      }
      this.loadTasks('applyFilter')
    },

    reportsPDF(): void {
      this.dialog.pdf.show = !this.dialog.pdf.show
    },

    onPdfReportsClose(): void {
      this.dialog.pdf.show = false
    },

    generatePDF(): void {
      let table_wrapper = this.$refs['descriptor_wrapper']
      if(table_wrapper?.generatePDF) {
        table_wrapper.generatePDF()
      }
      return
    },
    
    csvExport(): void {
      let table_wrapper = this.$refs['descriptor_wrapper']
      if(table_wrapper?.csvExport) {
        table_wrapper.csvExport()
      }
      return
    },

    selectRecord(record: TaskRecord): void {
      console.log('TASKS_JOURNAL', 'RECORD SELECTED: ', record)
      if (!record) return
      this.onRowOpen(record)
    },

    clickValue(row: TaskRecord, item: TableColumn): void {
      console.log('TASKS_JOURNAL', 'clickValue', 'row: ', row, 'item: ', item)
      if (!row) return
      this.onRowOpen(row)
    },

    onRowOpen(row: TaskRecord): void {
      console.log('onRowOpen', row)
      const mode = !!this.curRealArch ? 'archive' : 'realtime'
      const dialogData = {
        component: 'tasksModal',
        mode: mode,
        id: row.id,
        data: row,
      }
      this.$store.dispatch('setDialog', dialogData)
    },

    async onJournalBattonClick(page: string, index: number): Promise<void> {
      console.log('onJournalBattonClick', page, index)

      if (index === 1) {
        this.activeTab = index
        this.curRealArch = 0
      }
      if (index === 2) {
        this.activeTab = index
        this.curRealArch = 1
      }
      if (page === 'pdf') {
        // this.reportsPDF()
        this.generatePDF()
      }
      if (page === 'csv') {
        this.csvExport()
      }
      if (page === 'filter') {
        this.$set(this.bar.filter, 'open', !this.bar.filter.open)
      }
    },

    nextPage(): void {
      if (!!this.curRealArch) {
        this.archivePage++
      } else {
        this.page++
      }
      this.loadTasks()
    },

    prevPage(): void {
      if (!!this.curRealArch) {
        if (this.getPage == 0) return
        this.archivePage--
        this.loadTasks()
      } else {
        if (this.getPage == 0) return
        this.page--
        this.loadTasks()
      }
    },

    moveToPage(val: string): void {
      if (!!this.curRealArch) {
        if (val === 'first') {
          if (this.getPage == 0) return
          this.archivePage = 0
          this.loadTasks()
        }
        if (val === 'last') {
          if (this.getPage === this.totalArchivePages) return
          this.archivePage = this.totalArchivePages
          this.loadTasks()
        }
      } else {
        if (val === 'first') {
          if (this.getPage == 0) return
          this.page = 0
          this.loadTasks()
        }
        if (val === 'last') {
          if (this.getPage === this.totalPages) return
          this.page = this.totalPages
          this.loadTasks()
        }
      }
    },
  },
})
</script>

<style>

.journal-tab-button {
  font-size: 14px !important;
  height: 36px;
  background-color: #ebebeb !important;
  border-left: solid 1px #DCDCDC !important;
  border-right: solid 1px #DCDCDC !important;
  border-top: solid 1px #DCDCDC !important;
  border-bottom: solid 1px #DCDCDC !important;
  padding: 4px 20px 4px 20px;
  cursor: pointer;
}

</style>